import { render, staticRenderFns } from "./ChallengeView.vue?vue&type=template&id=2aba81f6&scoped=true&"
import script from "./ChallengeView.vue?vue&type=script&lang=js&"
export * from "./ChallengeView.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeView.vue?vue&type=style&index=0&id=2aba81f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba81f6",
  null
  
)

export default component.exports